import KeyMirror from 'keymirror';

export default KeyMirror({
    COMPLETE_FLOW: true,
    RESTART_FLOW: true,
});
